import "./Homepage.scss";
import "./react-grid-layout.scss";
import "./react-resizable.scss";
import { CSSProperties, useEffect, useMemo, useState, useCallback } from "react";
import { UserWidget } from "@/common/constants/online.homepagegateway.api";
import { useDragClickBlocker } from '@/common/hooks/useDragClickBlocker';
import GridLayout from 'react-grid-layout';
import GridLayoutItem from "./GridLayoutItem";
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from "@/react-app-env";
import { onDragStop, onWidgetResize, saveLayoutToDB } from "@/common/actions/widgetActions";
import { GRID_LAYOUT_GRID_ROW_HEIGHT, newWidgetsSessionStorageKey } from "@/common/utilities/widgetHelper";

export const WidgetsContent = () => {
  const userWidgets: UserWidget[] = useSelector((state: AppState) => state.widgetsState?.widgets);
  const widgetsLayout = useSelector((state: AppState) => state.widgetsState?.widgetsLayout);
  const widgetsContainerWidth = useSelector((state: AppState) => state.widgetsState?.widgetsContainerWidth);
  const gridColumns = useSelector((state: AppState) => state.widgetsState?.gridColumns);
  const dispatch = useDispatch();
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartTime, setDragStartTime] = useState(0);
  const gridUnitWidth = useMemo(() => {
    return Math.round(widgetsContainerWidth / gridColumns);
  }, [widgetsContainerWidth]);

  useEffect(() => {
    const handleUnload = () => {
      sessionStorage.removeItem(newWidgetsSessionStorageKey);
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);
  
  const onResizeCallback = (id: number, height: number) => {
    dispatch(onWidgetResize({id: id, newHeight: height}));
  }

  const OnDragStart = useCallback(() => {
    setIsDragging(true);
    setDragStartTime(Date.now());
  }, []);

  const OnDragStop = useCallback((newLayout: any) => {
    setIsDragging(false);
    dispatch(onDragStop(newLayout));
    dispatch(saveLayoutToDB(newLayout));
  }, [dispatch]);

  useDragClickBlocker(isDragging, dragStartTime);

  const gridLinesStyle :CSSProperties = {
    backgroundSize: `${gridUnitWidth}px ${gridUnitWidth}px`
  }

  return (
    <div id="homepage-content-grid">
      <GridLayout
          layout={widgetsLayout}
          width={widgetsContainerWidth}
          cols={gridColumns}
          rowHeight={GRID_LAYOUT_GRID_ROW_HEIGHT}
          autoSize={true}
          isDraggable={true}
          isResizable={false}
          margin={[0,0]}
          containerPadding={[0,0]}
          onDragStart={OnDragStart}
          onDragStop={OnDragStop}
          draggableHandle='.grid-layout-drag-handle'
          draggableCancel='.grid-layout-drag-cancel'
          style={gridLinesStyle}
          className={isDragging && gridColumns > 1 ? 'grid-lines' : ''}
          isBounded={true}
          >
          {
            userWidgets.map((widget) => <GridLayoutItem 
              key={widget.id.toString()}
              widget={widget}
              onResizeCallback={onResizeCallback}
            />)
          }
        </GridLayout>
    </div>
  );
}

export default WidgetsContent;